<template>
  <canvas
    :id="pickIndex + 'jacquardRow'"
    width="5"
    height="5"
    @click="handleCanvasClick"
  ></canvas>
</template>

<script>
import colorConverter from "../../utils/colorControlColors";
import { FILE_MODIFIED } from "../../../store/modules/uptData/constants";

export default {
  name: "JacquardRow",
  props: {
    jacquardData: { type: Array, required: true },
    squareDimension: { type: Number, required: true },
    pickIndex: { type: Number, required: true },
    colorIndex: { type: Number, default: null }
  },

  mounted: function() {
    this.setColor(this.colorIndex);
    this.draw();
  },

  data: function() {
    return {
      localColorIndex: null
    };
  },

  computed: {
    editJacquard() {
      return this.$store.state.uptData.editJacquard;
    }
  },

  watch: {
    squareDimension() {
      this.draw();
    },
    jacquardData() {
      this.draw();
    }
  },

  methods: {
    draw() {
      const color = colorConverter.getColorFromIndex(this.localColorIndex);
      var canvas = document.getElementById(this.pickIndex + "jacquardRow");
      if (canvas.getContext) {
        const ctx = canvas.getContext("2d");
        const width = (this.squareDimension + 2) * this.jacquardData.length;
        ctx.canvas.width = width;
        const height = this.squareDimension;
        ctx.canvas.height = height;
        ctx.fillStyle = color;
        ctx.strokeStyle = color;
        ctx.lineWidth = 1;
        this.jacquardData.forEach((jacquardValue, i) => {
          if (jacquardValue) {
            ctx.fillRect(
              i * this.squareDimension + i * 2,
              0,
              this.squareDimension,
              this.squareDimension
            );
          } else {
            ctx.strokeRect(
              i * this.squareDimension + i * 2 + 0.5,
              0 + 0.5,
              this.squareDimension - 1,
              this.squareDimension - 1
            );
          }
        });
      }
    },
    async handleCanvasClick(event) {
      if (this.editJacquard) {
        const clickedIndex = Math.floor(
          event.offsetX / (this.squareDimension + 2)
        );
        this.jacquardData[clickedIndex] =
          (this.jacquardData[clickedIndex] + 1) % 2;
        this.$store.dispatch(FILE_MODIFIED);
        this.draw();
      }
    },
    setColor(colorIndex) {
      this.localColorIndex = colorIndex;
    }
  }
};
</script>

<style scoped>
canvas {
  vertical-align: bottom;
}
</style>
